var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex centered-icon \n      align-items-center\n      justify-content-center \n      "},[(_vm.iconPath !== '')?_c('img',{staticClass:"centered-icon-image",attrs:{"src":_vm.iconPath,"srcset":_vm.srcSet}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }